export const RouteUrls = {
  SIDEDOOR_TOKEN_ENDPOINT_URL: "/sidedoor",
  INDEX_ENDPOINT: process.env.REACT_APP_UX_API_CONTEXT_PATH + "/v1/index",
  SUCCESS_ENDPOINT: process.env.REACT_APP_UX_API_CONTEXT_PATH + "/v1/success",
  SESSION_TIMEOUT_ENDPOINT: process.env.REACT_APP_UX_API_CONTEXT_PATH + "/v1/session-timeout",
  APP_LEVEL_PREFIX:  process.env.REACT_APP_LOGIN_UI_CONTEXT_PATH,
  HAS_ANONYMOUS_USER: process.env.REACT_APP_UX_API_CONTEXT_PATH + "/v1/validate/usryms",
  HAS_PRINCIPAL_USER: process.env.REACT_APP_UX_API_CONTEXT_PATH + "/v1/validate/usrpcl",
  HAS_ENTRY_USER: process.env.REACT_APP_UX_API_CONTEXT_PATH + "/v1/validate/usrtr",
  LOGIN_ENDPOINT: process.env.REACT_APP_UX_API_CONTEXT_PATH + "/v1/login",
  REGISTER_DEVICE_ENDPOINT: process.env.REACT_APP_UX_API_CONTEXT_PATH + "/v1/register-device",
  DEREGISTER_DEVICE_ENDPOINT: process.env.REACT_APP_UX_API_CONTEXT_PATH + "/v1/deregister-device",
  VALIDATE_DUPLICATE_USER_ENDPOINT : process.env.REACT_APP_UX_API_CONTEXT_PATH + "/v1/login/user/duplicate",
  GET_ACCESS_CODE: process.env.REACT_APP_UX_API_CONTEXT_PATH +"/v1/access-code",
  VERIFY_ACCESS_CODE: process.env.REACT_APP_UX_API_CONTEXT_PATH +"/v1/access-code/verify",
  CHANGE_PASSWORD: process.env.REACT_APP_UX_API_CONTEXT_PATH +"/v1/password/change",
  FORCED_CHANGE_PASSWORD: process.env.REACT_APP_UX_API_CONTEXT_PATH +"/v1/forcedPassword/change",
  EXPIRING_PASSWORD_CHANGE: process.env.REACT_APP_UX_API_CONTEXT_PATH +"/v1/expiringPassword/change",
  NEW_SET_SECRET_PHRASE:process.env.REACT_APP_UX_API_CONTEXT_PATH +"/v1/new-user/secret-phrase/set",
  CREDENTIAL_RECOVERY_ENDPOINT: process.env.REACT_APP_UX_API_CONTEXT_PATH +"/v1/forgot-userId",
  VERIFY_USERID: process.env.REACT_APP_UX_API_CONTEXT_PATH +"/v1/enroll/verify",
  ENROLL_USERID: process.env.REACT_APP_UX_API_CONTEXT_PATH +"/v1/enroll/userId",
  TARGET_REDIRECT_ENDPOINT: process.env.REACT_APP_UX_API_CONTEXT_PATH +"/v1/target-redirect",
  CREDENTIAL_RECOVERY_SUBMIT: process.env.REACT_APP_UX_API_CONTEXT_PATH +"/v1/credentialRecoverySubmit",
  TOKEN_ENDPOINT: "/token",
  PNET_LOGOFF_URL: "/app/logoff",
  YOUR_APP_GROUP_NAME: "/TRANSACTIONDETAIL",
  ENTITLEMENT_ENDPOINT: "/securedItems",
  ACCEPTED: 202,
  CONCURRENT_LOGIN_ERROR: 205,
    SEND_ANOTHER_REGISTRATION_ACCESS_CODE_ENDPOINT: process.env.REACT_APP_UX_API_CONTEXT_PATH + "/v1/send-registration-access-code"

}
export default RouteUrls;